<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>

    <ion-title
      class="ComparablesHeader__Title"
      [innerHTML]="(displayAddress$ | async) || 'Comparables'"
    ></ion-title>
    <ion-buttons slot="end">
      @if (showMapToggle) {
        <div class="p-2 col-6 d-flex justify-content-start align-items-center">
          <ion-checkbox
            (ionChange)="toggleMap()"
            [checked]="showMap"
          ></ion-checkbox>
          <label class="Comparables__MapToggleLabel"
            >&nbsp;&nbsp;Show Map</label
          >
        </div>
      }
      <ion-button
        aria-label="Filter button"
        color="primary"
        data-test-id="comparablesFilterButton"
        id="comps-filter-button"
        fill="clear"
        (click)="showFilter()"
      >
        <span [innerHTML]="'Filter Results'"></span>
        <ion-icon name="options" slot="end"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
